import React, {useEffect, useState} from 'react'
import ReactDOM from 'react-dom/client'

import {ShowSpace} from './ui/ShowSpace'
import {GuestSpace} from './ui/GuestSpace'
import './ui/styles.css'

/**
 * Hash routing, deliberately tiny: `#/guest/<slug>` renders a guest space
 * (Ticket 9); everything else renders the show space. Hash-based so the
 * static host needs no rewrite rules and the URL stays a bare asset path —
 * the guest being viewed never appears in a show-side request line.
 */
function routeFromHash(): {page: 'show'} | {page: 'guest'; slug: string} {
  const m = window.location.hash.match(/^#\/guest\/([a-z0-9-]+)$/)
  return m ? {page: 'guest', slug: m[1]} : {page: 'show'}
}

function App() {
  const [route, setRoute] = useState(routeFromHash)

  useEffect(() => {
    const onHash = () => setRoute(routeFromHash())
    window.addEventListener('hashchange', onHash)
    return () => window.removeEventListener('hashchange', onHash)
  }, [])

  return route.page === 'guest' ? <GuestSpace slug={route.slug} /> : <ShowSpace />
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
